import { render, staticRenderFns } from "./NuxtCookieConsent.vue?vue&type=template&id=31e4117b&"
import script from "./NuxtCookieConsent.vue?vue&type=script&lang=js&"
export * from "./NuxtCookieConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports